<template>
    <div>
        <SiteHeader style="width: 100%;"></SiteHeader>
        <NavbarStatic style="width: 100%"></NavbarStatic>

        <div style="margin-top: 30px;">
            <center>
                <h1 style="font-size: 4rem; font-family: Arial; color: #012376;"><strong>INQUIRE NOW</strong></h1>
            </center>
        </div>

        <div style="margin-top: 25px;">
            <div class="container">
                <div class="row">
                    <div class="col">&nbsp;</div>
                    <div class="col-md-6">
                        <center>
                            <el-input v-model="name" type="text" placeholder="Name of Applicant" style="width: 350px; margin-bottom: 5px;"></el-input>
                            <el-input v-model="course_level" type="text" placeholder="Course/Level being applide for" style="width: 350px; margin-bottom: 5px;" :maxlength="50"></el-input>
                            <el-input v-model="email" type="text" placeholder="Email Address" style="width: 350px; margin-bottom: 5px;"></el-input>
                            <el-input v-model="phone_no" type="text" placeholder="Mobile Number" style="width: 350px; margin-bottom: 5px;" @input="handlePhoneInput"></el-input>
                            <el-input v-model="landline_no" type="text" placeholder="Landline Number(Optional)" style="width: 350px; margin-bottom: 5px;"></el-input>
                            <div class="g-recaptcha" :data-sitekey="captcha_key"></div>
                            <el-button type="primary" @click="submitPreRegistration()" style="width: 350px;">SUBMIT</el-button>
                        </center>
                    </div>
                    <div class="col">&nbsp;</div>
                </div>
            </div>
        </div>


        <div style="margin-top: 100px; margin-bottom: 100px;">
            <div class="row" style="margin-right: 0%; margin-left: 0%">
                <div class="col-md-6">
                    &nbsp;
                </div>
                <div class="col-md-6">
                    <button @click="scrollToTop()" class="btn btn-ssa pull-right"><span style="font-family: Arial; font-size: 2rem; color: #ffffff;"><strong><i class="fa fa-angle-double-up" aria-hidden="true"></i>Back to Top</strong></span></button>
                </div>
            </div>
        </div>

        <div style="margin-top: 75px;">
            &nbsp;
        </div>
        <SiteFooter v-if="isWindowOnDesktop" :style="{backgroundImage: `url('${env_wp.APP_URL}/public/assets/img/ssa_manila/hompage/footer_assets/comp/footer_backdrop.png')`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', position: 'relative', width: '100%'}"></SiteFooter>
    </div>
</template>
<style>
    .el-collapse-item__header{
        display: flex;
        align-items: center;
        height: 48px;
        line-height: 48px;
        background-color: #012376;
        color: #ffffff;
        cursor: pointer;
        border-bottom: 1px solid #EBEEF5;
        font-size: 13px;
        font-weight: 500;
        transition: border-bottom-color .3s;
        outline: 0;
    }
    .el-collapse-item__content {
        padding-bottom: 25px;
        font-size: 13px;
        color: #012376;
        line-height: 1.769230769230769;
        margin-left: 25px;
        background-color: #f6f6f6;
        font-family: Arial;
    }
    .el-collapse-item__wrap {
        will-change: height;
        background-color: #f6f6f6;
        overflow: hidden;
        box-sizing: border-box;
        border-bottom: 1px solid #EBEEF5;
    }
</style>
<script>
    import SiteHeader from "../../../../components/general/SiteHeader";
    import NavbarStatic from "../../../../components/general/NavbarStatic";
    import SiteFooter from "../.../../../../../components/general/SiteFooter";
    export default {
        props: {
            captcha_key: String,
        },
        components: { SiteHeader,NavbarStatic,SiteFooter },
        data () {
            return {
                folder_name: this.$root.folder_name,
                env_wp: this.$root.env_wp.env_wp,
                name: '',
                course_level: '',
                email: '',
                phone_no: '',
                landline_no: '',
                screenWidth: 0,
                isWindowOnDesktop: true,
            }
        },
        watch:{
            
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize)
            });
            this.onResize();
            // setTimeout(() => {
            //     if (window.grecaptcha && document.querySelector('.g-recaptcha')) {
            //         window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
            //             sitekey: this.captcha_key
            //         });
            //     }
            // }, 1000);
        },
        created() {
            this.addSsaColorClass();
        },
        watch: {
            screenWidth(width) {
                if (width > 768) {
                    this.isWindowOnDesktop = true;
                } else {
                    this.isWindowOnDesktop = false;
                }
            },
        },
        methods: {
            scrollToTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            addSsaColorClass(){
                $(".el-collapse-item__header").css({
                    "background-color": "#012376",
                    "color": "#ffffff"
                });
            },
            validateEmail() {
                // Basic email pattern for validation
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(this.email)) {
                    this.$swal('Oops', 'Please enter a valid email address.', 'error');
                    return 0;
                }
                return 1;
            },
            submitPreRegistration(){
                if(this.name === ''){
                    this.$swal('Oops', 'Please enter your name.', 'error');
                    return;
                }

                if(this.course_level === ''){
                    this.$swal('Oops', 'Please enter the course/level applied for', 'error');
                    return;
                }

                if(this.email === ''){
                    this.$swal('Oops', 'Please enter your email.', 'error');
                    return;
                }

                if(this.validateEmail() == 0){
                    return;
                }

                if(this.phone_no === ''){
                    this.$swal('Oops', 'Please enter your mobile number.', 'error');
                    return;
                }

                const recaptchaResponse = window.grecaptcha ? window.grecaptcha.getResponse() : '';
                if (!recaptchaResponse) {
                    this.$swal('Oops', 'Please complete the CAPTCHA.', 'error');
                    return;
                }

                var params = {
                    name: this.name,
                    course_level: this.course_level,
                    email: this.email,
                    phone_no: this.phone_no,
                    landline_no: this.landline_no,
                    recaptcha: recaptchaResponse,
                };

                const loading = this.$loading({
                    lock: true,
                    text: 'Sending your Pre-Register Application, please wait...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios.post(this.env_wp.FOLDER_NAME+ '/submit_pre_registration', params)
                .then(res => {
                    if(res.data.status == 1){
                        loading.close();
                        this.$swal(res.data.title, res.data.text, res.data.type);
                        this.name = '';
                        this.course_level = '';
                        this.email = '';
                        this.phone_no = '';
                        this.landline_no = '';
                    }else{
                        this.$swal('Oops', 'Something went wrong while submitting your inquiry.', 'error');
                        loading.close();
                     }
                })
                .catch(err => {
                    loading.close();
                    console.log(err);
                })
            },
            handlePhoneInput(value) {
                const sanitizedInput = value.replace(/[^0-9+-]/g, '');
                this.phone_no = sanitizedInput;
            },
            onResize(event) {
                this.screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            },
        }
    }
</script>